import { API_URL } from 'sow/constants/api';
import { apiPost } from 'sow/utils/apiNew';

export const addStaff = (acaId, user) =>
  apiPost(`${API_URL}/v1/aca/${acaId}/admin`, user);
